import { render, staticRenderFns } from "./Rating-form.vue?vue&type=template&id=43f3b2f6&scoped=true&"
import script from "./Rating-form.vue?vue&type=script&lang=js&"
export * from "./Rating-form.vue?vue&type=script&lang=js&"
import style0 from "./Rating-form.vue?vue&type=style&index=0&id=43f3b2f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f3b2f6",
  null
  
)

export default component.exports